import React, { useState, useEffect } from "react";
import ComponentsTwo from "../compo-2";
import ComponenrThird from "../compo-3";
import ComponentFour from "../compo-4";
import Carousel from "react-bootstrap/Carousel";
import "./style.css";
function Rendering() {
  // const [show, setshow] = useState(true);
  // const [show2, setshow2] = useState(false);
  // const [show3, setshow3] = useState(false);

  // const createLoop = () => {
  //   if (show) {
  //     setshow(false);
  //     setshow2(true);
  //     setshow3(false);
  //   } else if (show2) {
  //     setshow(false);
  //     setshow2(false);
  //     setshow3(true);
  //   } else if (show3) {
  //     setshow(true);
  //     setshow2(false);
  //     setshow3(false);
  //   }
  // };

  // useEffect(() => {
  //   setTimeout(createLoop, 3000);
  // }, [show, show2, show3]);

  return (
    <div>
      <Carousel
        slide={false}
        indicators={false}
        controls={false}
        interval={2000}
      >
        <Carousel.Item>
          <ComponentsTwo />
        </Carousel.Item>
        <Carousel.Item>
          <ComponenrThird />
        </Carousel.Item>
        <Carousel.Item>
          <ComponentFour />
        </Carousel.Item>
      </Carousel>
      {/* {show && <ComponentsTwo />}
      {show2 && <ComponenrThird />}
      {show3 && <ComponentFour />} */}
    </div>
  );
}

export default Rendering;
